module.exports = __webpack_public_path__ + "static/media/riskStep4.f8056031.svg";